import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import { vendorApply } from "@/lib/api";
import { toast } from "sonner";
import { Store } from "lucide-react";

export default function VendorApplyDialog({ open, onOpenChange }) {
  const { user, refreshUser, formatApiError } = useApp();
  const navigate = useNavigate();
  const [shopName, setShopName] = useState("");
  const [phone, setPhone] = useState(user?.phone || "");
  const [city, setCity] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await vendorApply({ shop_name: shopName, phone, city, message });
      await refreshUser();
      toast.success("Aapki dukaan ready hai! Vendor Dashboard khul raha hai.");
      onOpenChange(false);
      navigate(r?.shop_id ? "/vendor?tab=shop" : "/vendor");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 overflow-hidden rounded-2xl" data-testid="vendor-apply-dialog">
        <div className="bg-gradient-to-br from-amber-500 to-amber-700 text-white px-6 pt-6 pb-8">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center"><Store className="w-5 h-5" /></div>
            <div className="font-display text-xl font-bold">Become a Vendor</div>
          </div>
          <DialogHeader>
            <DialogTitle className="text-2xl font-display font-bold text-white">Apni dukaan online laao</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-amber-50 mt-1">Fill your shop details. Your shop is created instantly — no waiting for approval.</p>
        </div>
        <form onSubmit={submit} className="p-6 space-y-3">
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Shop name*</label>
            <input value={shopName} onChange={(e) => setShopName(e.target.value)} required minLength={2} maxLength={100} placeholder="e.g. Sharma General Store" className="w-full mt-1 border border-slate-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-emerald-500" data-testid="vendor-shop-name" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Phone*</label>
            <input value={phone} onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))} required minLength={10} placeholder="10-digit number" className="w-full mt-1 border border-slate-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-emerald-500" data-testid="vendor-phone" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">City</label>
            <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="e.g. New Delhi" className="w-full mt-1 border border-slate-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-emerald-500" data-testid="vendor-city" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Message (optional)</label>
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={3} placeholder="Tell us about your shop..." className="w-full mt-1 border border-slate-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-emerald-500" data-testid="vendor-message" />
          </div>
          {error && <div className="text-xs bg-red-50 text-red-700 border border-red-100 rounded-lg px-3 py-2">{error}</div>}
          <button type="submit" disabled={loading} className="w-full bg-emerald-700 hover:bg-emerald-800 disabled:opacity-60 text-white rounded-xl py-3 text-sm font-semibold" data-testid="vendor-apply-submit">
            {loading ? "Creating shop..." : "Create my shop"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
